class RepertoireListByAge extends Component {
    constructor(el) {
        super(el);
        this.swiperEl = this.$find('[data-home-repertoire-by-age-swiper]');
        this.swiper = null;
        this.swiperEl && this.constructSwiper();
    }

    constructSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
            slidesPerView: 1,
            spaceBetween: 40,
            navigation: {
                prevEl: this.$find('[data-home-repertoire-by-age-swiper-prev]'),
                nextEl: this.$find('[data-home-repertoire-by-age-swiper-next]'),
            },
            breakpoints: {
                1600: {
                    slidesPerView: 3,
                    spaceBetween: 40,
                },
                1300: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
                480: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                }
            }
        });
    }
}
